<div class="playlistWrapper" (click)="onSelect()">
  @if (isQueue) {
    <tun-add-to-queue-v5 class="icon icon-scaled-svg-button frontIcon queueIcon"></tun-add-to-queue-v5>
  }
  @if (isFavorite) {
    <tun-thumb-up-icon-v5 class="icon icon-scaled-svg-button frontIcon"></tun-thumb-up-icon-v5>
  }
  <div class="playlistTitleContainer">
    <tun-scrollable-text class="playlistTitle" [text]="title"></tun-scrollable-text>
  </div>
</div>
